import React from 'react'
const Main = (props) => {
return <h1>Lets Looks at some stock! Click on stocks to see some</h1>
}
export default Main